import { _keys, BadImplementationException, cloneObj, composeUrl, deepClone, exists, Logger, mergeObject, Module } from '@nu-art/ts-common';
import { ModuleFE_RoutingV2, ModuleFE_Thunderstorm, StorageKey, ThunderDispatcher } from '@nu-art/thunderstorm-frontend/index';
import { convertBase64ToObject, convertObjectToBase64 } from '@nu-art/thunderstorm-shared/base64-tools';
import { URLParam_AppState } from './consts.js';
export const dispatch_OnPageStateUpdated = new ThunderDispatcher('__onPageStateUpdated');
class ModuleFE_AppState_Class extends Module {
    pathRegistry;
    appState;
    localStorage;
    sessionStorage;
    constructor() {
        super();
        this.localStorage = new StorageKey('app-state', true);
        this.sessionStorage = new StorageKey('app-state', false);
        this.pathRegistry = {};
        this.appState = this.sessionStorage.get(() => this.localStorage.get({}));
        this.deriveStateFromURLParam();
    }
    registerManager = (manager) => {
        if (exists(this.pathRegistry[manager.route]))
            throw new BadImplementationException(`A manager is already registered for route: ${manager.route}`);
        this.pathRegistry[manager.route] = manager;
    };
    // ######################### State Interaction #########################
    setPageState = (manager, state) => {
        this.appState[manager.route] = state;
        this.sessionStorage.set(this.appState);
        this.localStorage.set(this.appState);
    };
    getPageState = (manager) => this.appState[manager.route] ?? {};
    // ######################### Import / Export #########################
    deriveStateFromURLParam = () => {
        const encoded = ModuleFE_RoutingV2.getQueryParameter(URLParam_AppState);
        if (!exists(encoded))
            return;
        const decoded = this.decodeState(encoded);
        _keys(decoded).forEach(key => {
            this.appState[key] = mergeObject(this.appState[key], decoded[key]);
        });
        ModuleFE_RoutingV2.removeQueryParam(URLParam_AppState);
    };
    getExportStateForManager = (manager) => {
        const pageState = this.getPageState(manager);
        const appState = { [manager.route]: pageState };
        const encoded = this.encodeState(appState);
        const baseUrl = window.location.origin + manager.route;
        return composeUrl(baseUrl, { [URLParam_AppState]: encoded });
    };
    encodeState = (decoded) => {
        return convertObjectToBase64(decoded);
    };
    decodeState = (encoded) => {
        return convertBase64ToObject(encoded);
    };
}
const ModuleFE_AppState = new ModuleFE_AppState_Class();
export class PageStateManager extends Logger {
    route;
    constructor(route) {
        super();
        this.route = route;
        ModuleFE_AppState.registerManager(this);
    }
    // ######################### State Interaction #########################
    value = {
        get: (stateKey) => {
            const pageState = this.state.get();
            return pageState[stateKey];
        },
        set: (stateKey, value) => {
            const _value = deepClone(value);
            const nextPageState = this.state.get();
            nextPageState[stateKey] = _value;
            ModuleFE_AppState.setPageState(this, nextPageState);
        }
    };
    state = {
        get: () => {
            return ModuleFE_AppState.getPageState(this);
        },
        set: (state) => {
            const prevPageState = this.state.get();
            const nextPageState = mergeObject(prevPageState, cloneObj(state));
            ModuleFE_AppState.setPageState(this, nextPageState);
        }
    };
    // ######################### Utils #########################
    getDispatchListenerCB = (cb) => {
        return (manager) => {
            if (manager === this)
                cb();
        };
    };
    getExportURL = () => {
        const url = ModuleFE_AppState.getExportStateForManager(this);
        ModuleFE_Thunderstorm.copyToClipboard(url, 'Export URL copied to clipboard');
    };
}
//# sourceMappingURL=ModuleFE_AppState.js.map